import React from 'react'
import { Typography } from '@mui/material';
import Policy from './Policy'
import { CancellationData } from 'pages/individualPages/JSON/CancellationData';
import PolicyHeader from './PolicyHeader';

function AboutUs() {
  const searchParams = new URLSearchParams(window.location.search);
  const type = searchParams.get('type');
  const isMobileParams = searchParams.get('isMobile') === 'true';
  return (
    <div>
      {(type && isMobileParams) ?
        <div>
          <Policy policyData={CancellationData} />
        </div>
        : 
          <div>
            <PolicyHeader />
            <Typography className='policyHeading'>About Us</Typography>
            <Policy policyData={CancellationData} />
          </div>
          }
    </div>
  )
}

export default AboutUs
